export default __webpack_public_path__ + "static/media/star_empty.62ce6158.svg";